import React, { useEffect } from 'react';

function AdSpace({ slot, format = 'auto', responsive = true, style = {} }) {
    useEffect(() => {
        try {
            // Inicializar ad cuando el componente se monta
            if (window.adsbygoogle) {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            }
        } catch (err) {
            console.log('AdSense error:', err);
        }
    }, []);

    return (
        <div className="ad-container" style={style}>
            <ins 
                className="adsbygoogle"
                style={{ display: 'block' }}
                data-ad-client="ca-pub-8813648345832372"
                data-ad-slot={slot}
                data-ad-format={format}
                data-full-width-responsive={responsive.toString()}
            />
        </div>
    );
}

export default AdSpace;